export type PdfLogEvent = "start" | "success" | "failure";

const EVENT_NAME = "consents.pdf";

// No app logger exists; keep one consistent event name for PDF diagnostics.
export function logPdf(event: PdfLogEvent, fields: Record<string, unknown>): void {
  // oxlint-disable-next-line no-console
  const log = event === "failure" ? console.error : console.info;
  log(EVENT_NAME, event, fields);
}
